import { render, staticRenderFns } from "./ApplicantStudentExaminationPoint.vue?vue&type=template&id=0f2c3d6a&"
import script from "./ApplicantStudentExaminationPoint.vue?vue&type=script&lang=js&"
export * from "./ApplicantStudentExaminationPoint.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantStudentExaminationPoint.vue?vue&type=style&index=0&id=0f2c3d6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports